// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component } from "react";
const RIOTBAR_SCRIPT_ID = "riotbar-script";
export default class RiotBarLoader extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // start loading
        this.loadRiotBar();
    }
    render() {
        return null; // we dont actually render anything, the riotbar script does
    }
    getRiotBarUrl() {
        const { environment = "live", version = "latest", locale, product } = this.props;
        const cdnHost = "cdn.rgpub.io";
        const standardEnvironments = ["test", "preview", "live"];
        const invalidLiveEnvironments = ["production", "prod"];
        let accessLevel = "private";
        if (invalidLiveEnvironments.includes(environment)) {
            throw new Error("invalid environment name, please use `live` to access the production riotbar");
        }
        if (environment === "live") {
            accessLevel = "public";
        }
        if (!standardEnvironments.includes(environment)) {
            console.warn(`you are using a nonstandard riotbar environment: ${environment}`);
        }
        return `https://${cdnHost}/${accessLevel}/${environment}/riotbar/${version}/${product}.${locale}.js`;
    }
    loadRiotBar() {
        if (!document.getElementById(RIOTBAR_SCRIPT_ID)) {
            const scriptEl = document.createElement("script");
            scriptEl.src = this.getRiotBarUrl();
            scriptEl.id = RIOTBAR_SCRIPT_ID;
            if (this.props.onLoad && typeof this.props.onLoad === "function") {
                const onloadFunc = this.props.onLoad;
                document.addEventListener("riotbar_onshowcomplete", function () {
                    onloadFunc();
                });
            }
            if (this.props.onAuthUpdate && typeof this.props.onAuthUpdate === "function") {
                const onAuthUpdateFunc = this.props.onAuthUpdate;
                document.addEventListener("riotbar_authcheckcomplete", function () {
                    onAuthUpdateFunc();
                });
            }
            document.getElementsByTagName("head")[0].appendChild(scriptEl);
        }
    }
}
